// Elle specific component
export const standalone = () => null;
export default standalone;
